"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractEntityColumnDescription = exports.AbstractEntityEmbeddedDescription = exports.AbstractEntityDescription = exports.SimplifiedRelationType = exports.SimplifiedColumnTypeEnum = void 0;
var SimplifiedColumnTypeEnum;
(function (SimplifiedColumnTypeEnum) {
    SimplifiedColumnTypeEnum["INTEGER"] = "integer";
    SimplifiedColumnTypeEnum["FLOAT"] = "float";
    SimplifiedColumnTypeEnum["PRECISION"] = "precision";
    SimplifiedColumnTypeEnum["TEXT"] = "text";
    SimplifiedColumnTypeEnum["UUID"] = "uuid";
    SimplifiedColumnTypeEnum["BOOLEAN"] = "boolean";
    SimplifiedColumnTypeEnum["JSON"] = "json";
    SimplifiedColumnTypeEnum["DATETIME"] = "datetime";
    SimplifiedColumnTypeEnum["ENUM"] = "enum";
    SimplifiedColumnTypeEnum["RELATION"] = "relation";
    SimplifiedColumnTypeEnum["UNKNOWN"] = "unknown";
})(SimplifiedColumnTypeEnum = exports.SimplifiedColumnTypeEnum || (exports.SimplifiedColumnTypeEnum = {}));
var SimplifiedRelationType;
(function (SimplifiedRelationType) {
    SimplifiedRelationType[SimplifiedRelationType["ONE_TO_ONE"] = 0] = "ONE_TO_ONE";
    SimplifiedRelationType[SimplifiedRelationType["ONE_TO_MANY"] = 1] = "ONE_TO_MANY";
    SimplifiedRelationType[SimplifiedRelationType["MANY_TO_ONE"] = 2] = "MANY_TO_ONE";
    SimplifiedRelationType[SimplifiedRelationType["MANY_TO_MANY"] = 3] = "MANY_TO_MANY";
})(SimplifiedRelationType = exports.SimplifiedRelationType || (exports.SimplifiedRelationType = {}));
class AbstractEntityDescription {
}
exports.AbstractEntityDescription = AbstractEntityDescription;
class AbstractEntityEmbeddedDescription {
}
exports.AbstractEntityEmbeddedDescription = AbstractEntityEmbeddedDescription;
class AbstractEntityColumnDescription {
}
exports.AbstractEntityColumnDescription = AbstractEntityColumnDescription;
AbstractEntityColumnDescription.integerColumnTypes = new Set([
    'int',
    'int2',
    'int4',
    'int8',
    'integer',
    'tinyint',
    'smallint',
    'mediumint',
    'bigint',
]);
AbstractEntityColumnDescription.floatColumnTypes = new Set([
    'float',
    'double',
    'double precision',
    'real',
]);
AbstractEntityColumnDescription.precisionColumnTypes = new Set([
    'dec',
    'decimal',
    'smalldecimal',
    'fixed',
    'numeric',
    'number',
]);
AbstractEntityColumnDescription.textColumnTypes = new Set([
    'text',
    'character varying',
    'varying character',
    'char varying',
    'nvarchar',
    'national varchar',
    'character',
    'native character',
    'varchar',
    'char',
    'nchar',
    'national char',
    'varchar2',
    'nvarchar2',
    'alphanum',
    'shorttext',
    'string',
]);
AbstractEntityColumnDescription.jsonColumnTypes = new Set(['simple-json', 'json', 'jsonb']);
//# sourceMappingURL=types.js.map